import { Sizes } from '@/ui/theme/types';
import { maxContentWidth } from '@/ui/theme/layout';

export const sizes: Sizes = {
  maxContentWidth,
};
